var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.exibir),callback:function ($$v) {_vm.exibir=$$v},expression:"exibir"}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_c('br'),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }